module.exports = __webpack_public_path__ + "static/media/people.d423e817.svg";